import axios from "axios";
import React, { Component } from "react";
import { Button, Modal } from "react-bootstrap";
import "../../../Utils/_assets/sass/feedback.scss";
import { API_ENDPOINTS } from "../../util/constants";
import { FeedbackComponent } from "./Form";

export default class FeedbackButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayFeedbackModal: false,
      questionList: [],
    };
  }

  componentDidMount() {
    this.getFeedbackQuestions();
  }

  shouldComponentUpdate22(){
    return false
  }

  getFeedbackQuestions = async () => {
    const url = API_ENDPOINTS.getFeedbackQuestionSet;
    try {
      const response = await axios.get(url);
      this.setState({ questionList: response.data.questions });
      return response;
    } catch (error) {
      return error.response;
    }
  };

  handleFeedbackFormModal = () => {
    this.setState({ displayFeedbackModal: !this.state.displayFeedbackModal });
  };

  closeFeedbackFormModal = () => this.setState({ displayFeedbackModal: false });

  render() {
    return (
      <>
        <Modal
          show={this.state.displayFeedbackModal}
          dialogClassName="feedback-dialog"
          backdrop={false}
          autoFocus
          scrollable={true}
          animation={false}
          size="lg"
        >
          <Modal.Body>
            <FeedbackComponent
              questionList={this.state.questionList}
              closeFeedbackFormModal={this.closeFeedbackFormModal.bind(this)}
            />
          </Modal.Body>
        </Modal>
        <div>
          <Button
            className={
              "btn feedback-btn " +
              (this.state.displayFeedbackModal ? "feedback-close-btn" : "")
            }
            onClick={() => {
              this.handleFeedbackFormModal();
            }}
          >
            {this.state.displayFeedbackModal ? (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  fill="white"
                  viewBox="0 0 16 16"
                >
                  <path d="M1.293 1.293a1 1 0 0 1 1.414 0L8 6.586l5.293-5.293a1 1 0 1 1 1.414 1.414L9.414 8l5.293 5.293a1 1 0 0 1-1.414 1.414L8 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414L6.586 8 1.293 2.707a1 1 0 0 1 0-1.414z" />
                </svg>
                <span className="feeback-btn-label">Close</span>
              </>
            ) : (
              <>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  fill="white"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm5.507 13.941c-1.512 1.195-3.174 1.931-5.506 1.931-2.334 0-3.996-.736-5.508-1.931l-.493.493c1.127 1.72 3.2 3.566 6.001 3.566 2.8 0 4.872-1.846 5.999-3.566l-.493-.493zm-9.007-5.941c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5zm7 0c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5-.672-1.5-1.5-1.5z" />
                </svg>
                <span className="feeback-btn-label">Feedback</span>
              </>
            )}
          </Button>
        </div>
      </>
    );
  }
}
